/**
 * Analytics utility for tracking visitor data
 * Sends visitor information to Lambda function
 */

export const trackVisitor = async () => {
  try {
    const visitorData = {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      language: navigator.language,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const apiEndpoint = process.env.REACT_APP_ANALYTICS_ENDPOINT;
    if (!apiEndpoint) {
      console.log('Analytics endpoint is not configured. Skipping tracking.');
      return;
    }

    await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(visitorData),
    }).catch(err => console.log('Analytics tracking error:', err));

  } catch (error) {
    console.log('Error tracking visitor:', error);
  }
};

/**
 * Track specific events on the page
 */
export const trackEvent = async (eventName, eventData = {}) => {
  try {
    const payload = {
      eventName,
      eventData,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    };

    const apiEndpoint = process.env.REACT_APP_ANALYTICS_ENDPOINT;
    if (!apiEndpoint) {
      console.log('Analytics endpoint is not configured. Skipping event tracking.');
      return;
    }

    await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch(err => console.log('Event tracking error:', err));

  } catch (error) {
    console.log('Error tracking event:', error);
  }
};
